import { ArrowRightIcon } from "components/icons";

import { TTabeField, TTableRecord } from "components/Table/types";

export interface FieldActionListProps {
  field?: TTabeField;
  record?: TTableRecord;
}

const FieldActionIcon = ({ field, record }: FieldActionListProps) => {
  const handleOnClickActionItem = () => {
    if (field?.onClick) {
      field?.onClick(record);
    }
  };

  return (
    <div className="w-full flex items-center justify-center cursor-pointer">
      {field?.icon ? (
        <div onClick={handleOnClickActionItem} className="inline-flex">
          {field.icon}
        </div>
      ) : (
        <ArrowRightIcon stroke="#868686" onClick={handleOnClickActionItem} />
      )}
    </div>
  );
};

export default FieldActionIcon;
